import Footer from "../components/Home/Footer.js";
import Navbar  from "../components/NavBar/NavBar.js";
import SectionServices from "../components/Services/SectionServices.js"
import Whatsapp from "../components/Home/Whatsapp.js";
import Spinner from "../components/Home/Spinner.js";
import { useEffect } from "react";




const Services = () =>{
    useEffect(() => {
  document.title =
    "UNIK SYSTEM | Nos Services & Solutions Techniques";

  const meta = document.querySelector("meta[name='description']");
  if (meta) {
    meta.setAttribute(
      "content",
      "Découvrez l’ensemble des services UNIK SYSTEM : conception, fabrication et installation de solutions architecturales, acoustiques, lumineuses et solaires."
    );
  }
}, []);

    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <SectionServices/>
            <Whatsapp/>
            <Footer/>
        </div>    
    )
};

export default Services;